/**
 * Limpa todos os caches do Service Worker (Workbox).
 * Usado ao clicar "Atualizar" no toast de nova versão e no logout
 * para evitar dados obsoletos ou erros de fetch após atualização.
 */
export const clearPwaCaches = async (): Promise<void> => {
  if (!('caches' in window)) return
  try {
    const names = await caches.keys()
    await Promise.all(names.map((name) => caches.delete(name)))
  } catch {
    // Ignora falhas (ex.: em modo privado)
  }
}
